import { getPreCompanyByLegalId } from "~/context/PreCompanies/application/getPreCompanyByLegalId";
import { Dependencies } from "~/context/Shared/infrastructure/Dependencies";
import { getPreCompaniesByUser } from "~/context/PreCompanies/application/getPreCompaniesByUser";
import { getPreCompaniesByPreUser } from "~/context/PreCompanies/application/getPreCompaniesByPreUser";

export async function usePreCompanyByLegalId(
  legalId: string,
) {
  try {
    console.log("usePreCompanyByLegalId legalId:" + legalId);
    const ret = await getPreCompanyByLegalId(Dependencies.getInstance().getPreCompanyRepository(), legalId);
    return ret;
  } catch (error) {
    console.log("usePreCompanyByLegalId error", JSON.stringify(error));
    return null;
  }
}

export async function usePreCompanyByUser(userId: string) {
  try {
    console.log("usePreCompaniesByUser:" + userId);
    const ret = await getPreCompaniesByUser(Dependencies.getInstance().getPreCompanyRepository(), userId);
    return ret;
  } catch (error) {
    console.log("usePreCompanyByLegalId error", JSON.stringify(error));
    return null;
  }
}

export async function usePreCompanyByPreUser() {
  try {
    console.log("usePreCompaniesByPreUser:");
    const ret = await getPreCompaniesByPreUser(Dependencies.getInstance().getPreCompanyRepository());
    return ret;
  } catch (error) {
    console.log("usePreCompanyByLegalId error", JSON.stringify(error));
    return null;
  }
}
